export default "__VITE_ASSET__6c318c4d__"